module.exports = __webpack_public_path__ + "static/media/Host_Available_Property_Banned.24be8ee4.png";